import * as XLSX from 'xlsx-js-style';
import type { CellStyle, WorkSheet } from 'xlsx-js-style';

const HEADER_CELL_STYLE: CellStyle = {
  font: { bold: true, color: { rgb: '000000' } },
  fill: { fgColor: { rgb: 'FFFF00' }, patternType: 'solid' },
  alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
  border: {
    top: { style: 'thin', color: { rgb: 'B4B4B4' } },
    bottom: { style: 'thin', color: { rgb: 'B4B4B4' } },
    left: { style: 'thin', color: { rgb: 'B4B4B4' } },
    right: { style: 'thin', color: { rgb: 'B4B4B4' } },
  },
};

/** Character widths (`wch`) — matches Incident & Request Ageing layout (wide description, narrow priority/state/duration). */
export function setSheetColumnWidths(ws: WorkSheet, widths: number[]): void {
  ws['!cols'] = widths.map((wch) => ({ wch }));
}

/** Yellow header row + AutoFilter on row 1 (matches legacy Incident & Request Ageing exports). */
export function applyYellowHeaderRowAndAutofilter(ws: WorkSheet, columnCount: number, rowCount: number): void {
  for (let c = 0; c < columnCount; c++) {
    const addr = XLSX.utils.encode_cell({ r: 0, c });
    const cell = ws[addr];
    if (cell) {
      cell.s = HEADER_CELL_STYLE;
    }
  }
  if (rowCount >= 1 && columnCount >= 1) {
    const lastColLetter = XLSX.utils.encode_col(columnCount - 1);
    ws['!autofilter'] = { ref: `A1:${lastColLetter}${rowCount}` };
  }
}
